export default "__VITE_ASSET__CYYTCXiU__"